export const COMPANY_NAME = '深圳市聚蜂领航科技有限公司'
export const COMPANY_SHORT_NAME = '聚蜂获客'



// WEBPACK FOOTER //
// ./src/constants/index.js